import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { setCountryOfResidenceAction } from '../ducks/requestDuck';
import { getCountryOfResidence } from '../selectors/requestSelectors';

const useSetCountryOfResidenceHooks = () => {
  const activeLocale = useSelector(getActiveLocaleSelector);
  const countryOfResidence = useSelector(getCountryOfResidence);
  const dispatch = useDispatch();
  useEffect(() => {
    const delimiter = '-';
    const [language, country] = activeLocale?.split(delimiter) || '';
    if (!countryOfResidence && language && country) {
      dispatch(setCountryOfResidenceAction(country));
    }
  }, []);
};

export default useSetCountryOfResidenceHooks;
